// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* selfServices **********************************************************************
const INDEX_FEED_SELF_SERVICES_SUCCESS = "INDEX_FEED_SELF_SERVICES_SUCCESS";
const SHOW_FEED_SELF_SERVICE_SUCCESS = "SHOW_FEED_SELF_SERVICE_SUCCESS";
const STORE_FEED_SELF_SERVICE_SUCCESS = "STORE_FEED_SELF_SERVICE_SUCCESS";
const UPDATE_FEED_SELF_SERVICE_SUCCESS = "UPDATE_FEED_SELF_SERVICE_SUCCESS";
const DESTROY_FEED_SELF_SERVICE_SUCCESS = "DESTROY_FEED_SELF_SERVICE_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* selfServices **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_FEED_SELF_SERVICES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_FEED_SELF_SERVICE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_FEED_SELF_SERVICE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_FEED_SELF_SERVICE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_FEED_SELF_SERVICE_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* selfServices **********************************************************************

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("SelfService@index") || app.can("Reserve@index")) {
      api
        .get("/feeding/self_service", { params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.Indexing SelfServices Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.SelfService",
              "SelfService"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySelfServices() {
  return _indexSuccess({ data: { selfServices: [] }, meta: {} });
}

/**
 *
 * @param {Number} selfService
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(selfService, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("SelfService@index")) {
      api
        .get(`/feeding/self_service/${selfService}`, { params })
        .then((res) => {
          dispatch(_showSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.Indexing SelfService Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.SelfService",
              "SelfService"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySelfService() {
  return _showSuccess({ data: { selfService: {} }, meta: {} });
}

/**
 *
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("SelfService@store")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Adding New SelfService")
      );

      api
        .post("/feeding/self_service", { data: { selfService: data }, params })
        .then((res) => {
          dispatch(_storeSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.feed.New SelfService Added Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "خطا در ارسال اطلاعات",
              app.translate("routes.home.feed.Adding New SelfService Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.SelfService",
              "SelfService"
            )} - ${app.translate(
              "routes.home.basic.permission.store",
              "store"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} selfService
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(selfService, data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("SelfService@update")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Updating SelfService")
      );

      api
        .put(`/feeding/self_service/${selfService}`, {
          data: { selfService: data },
          params,
        })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.SelfService Updated Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "عملیات بروزرسانی با شکست مواجه شد",
              app.translate("routes.home.feed.Updating SelfService Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.SelfService",
              "SelfService"
            )} - ${app.translate(
              "routes.home.basic.permission.update",
              "update"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} selfService
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(selfService, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("SelfService@destroy")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Removing SelfService")
      );

      api
        .delete(`/feeding/self_service/${selfService}`, { params })
        .then((res) => {
          dispatch(_destroySuccess(selfService));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.SelfService Removed Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "عملیات حذف با شکست مواجه شد",
              app.translate("routes.home.feed.Removing SelfService Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.SelfService",
              "SelfService"
            )} - ${app.translate(
              "routes.home.basic.permission.destroy",
              "destroy"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    selfServices: [],
    selfService: {},
    meta: {},
  },
  action
) {
  let selfServices;
  let _index;
  switch (action.type) {
    case INDEX_FEED_SELF_SERVICES_SUCCESS:
      return Object.assign({}, state, {
        selfServices: action.payload.data.selfServices,
        meta: action.payload.meta,
      });
    case SHOW_FEED_SELF_SERVICE_SUCCESS:
      return Object.assign({}, state, {
        selfService: action.payload.selfService,
      });
    case STORE_FEED_SELF_SERVICE_SUCCESS:
      selfServices = app._.cloneDeep(state.selfServices);
      selfServices.push(action.payload);
      return Object.assign({}, state, {
        selfServices,
      });
    case UPDATE_FEED_SELF_SERVICE_SUCCESS:
      selfServices = app._.cloneDeep(state.selfServices);
      _index = selfServices.findIndex(
        (_selfService) => _selfService.id === action.payload.id
      );
      selfServices[_index] = action.payload;
      return Object.assign({}, state, {
        selfServices,
      });
    case DESTROY_FEED_SELF_SERVICE_SUCCESS:
      selfServices = app._.cloneDeep(state.selfServices);
      _index = selfServices.findIndex(
        (_selfService) => _selfService.id === action.payload
      );
      selfServices.splice(_index, 1);
      return Object.assign({}, state, {
        selfServices,
      });
    default:
      return state;
  }
}
